import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import CreateClientUserForm from "../components/ClientUserCreate";

export default function ClientUserCreateScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation("user");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={t("userCreateScreen.title")}>
                <CreateClientUserForm
                    onSubmitted={() => {
                        navigate(`..`);
                    }}
                />
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
